import { Injectable, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DbService } from "../../services/db/db.service";

@Injectable({
  providedIn: 'root'
})

export class PaymentService {

  private sslczPopUp: any;

  constructor(private db: DbService) {}

  // Google Pay Provider Code.................................................................
  paymentProcessStatus = new EventEmitter<any>();

  processPayment(user_id: number, user_email: string, region: string, item: any): void {
    const data = {
      "store_id": environment.sslczID,
      "store_passwd": environment.sslczPass,
      "total_amount": item.amount,
      "currency": "USD",
      "tran_id": `TR-${Date.now()}`,
      "success_url": `${environment.apiUrl}/sslcz_payment_success`,
      "fail_url": `${environment.apiUrl}/sslcz_payment_failed`,
      "cancel_url": `${environment.apiUrl}/sslcz_payment_canceled`,
      "cus_email": user_email,
      "cus_phone": "01611000000",
      "cus_add1": "Dhaka",
      "cus_city": "Dhaka",
      "cus_country": region,
      "user_id": user_id,
      "user_type": "Customer",
      "product_id": item.id,
      "shipping_method": "NO",
      "product_name": item.name,
      "product_category": "Digital",
      "product_profile": "non-physical-goods"
    };

    this.db.getSSLCheckOutUrl(data).subscribe((result: any) => {
      console.log(result);
      if(result.status === "SUCCESS"){
        this.paymentProcessStatus.emit("pay-started");
        this.openPaymentModal(data, item,  result.GatewayPageURL);
      }else{
        this.paymentProcessStatus.emit("pay-failed");
      }
    });
  }

  openPaymentModal(data: any, item: any, paymentUrl: string): void {
    // Insert Payment Data With Pending Status then open checkout window
    const paymentData = {"type": item.type, "tran_id": data.tran_id, "bank_tran_id": "", "val_id": "", "user_id": data.user_id, "user_type": "Customer", "status": "PENDING", "duration": item.duration, "amount": data.total_amount, "discount": item.discount, "gateway_name": "SSLCommerz", "data": ""};
    this.db.addPayment(paymentData).subscribe((result: any) => {
      console.log(result);
      if(result.status_code === 1){
        this.sslczPopUp = window.open(paymentUrl, 'sslczPopUp', "popup");
        this.checkPaymentStatus(data.tran_id);
      }else{
        console.log('Cannot Insert Payment Data In DB!!');
        this.paymentProcessStatus.emit("pay-failed");
      }
    });
  }

  checkPaymentStatus(tran_id: string): void {
    this.db.getSSLCZPaymentStatus(tran_id).subscribe((result: any) => {
      console.log(result);
      if(result.status_code === 1){
        const status = result.data[0].status;
        if(status === "VALID"){
          // Call Validation API To Complete Transaction
          const valID = result.data[0].val_id;
          const validationData = {"val_id": valID, "store_id": environment.sslczID, "store_passwd": environment.sslczPass};
          this.db.validateSSLCZPayment(validationData).subscribe((result: any) => {
            console.log(result);
            if(result.status_code === 1){
              console.log('Payment Validated!');
              this.paymentProcessStatus.emit("pay-success");
              this.sslczPopUp.close();
            }else{
              console.log('Cannot Validate Payment');
              this.paymentProcessStatus.emit("pay-invalid");
            }
          });
        }else if(status === "VALIDATED"){
          console.log('Payment Successful!');
          this.paymentProcessStatus.emit("pay-success");
          this.sslczPopUp.close();
        }else if(status === "FAILED"){
          console.log('Payment Failed!');
          this.paymentProcessStatus.emit("pay-failed");
          this.sslczPopUp.close();
        }else if(status === "CANCELLED"){
          console.log('Payment Canceled!');
          this.paymentProcessStatus.emit("pay-canceled");
          this.sslczPopUp.close();
        }else if(status === "PENDING"){
          if(this.sslczPopUp.closed){
            console.log('Payment Canceled!');
            this.paymentProcessStatus.emit("pay-canceled");
            this.sslczPopUp.close();
          }else{
            setTimeout(() => {
              this.checkPaymentStatus(tran_id);
            }, 2000);
          }
        }else{
          console.log('Payment Invalid!');
          this.paymentProcessStatus.emit("pay-invalid");
          this.sslczPopUp.close();
        }
      }
    });
  }

}
